import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AlertController, Platform, ViewController} from 'ionic-angular';
import {Subscription} from 'rxjs';
import {fromEvent} from 'rxjs/observable/fromEvent';
import {ReducceService} from '../../shared/services/reducce.service';


@Component({
  selector: 'core-cgv-modal',
  templateUrl: './cgv-modal.component.html'
})
export class CgvModalComponent implements OnInit, OnDestroy {

  public loading: boolean;
  public error: boolean;
  public cgv: string;
  private backbuttonSubscription: any;

  public constructor(private platform: Platform, public viewCtrl: ViewController, private reducceService: ReducceService) {
  }

  ngOnInit(): void {
    this.loading = false;
    this.error = false;

    this.getCGV();
    this.backbuttonSubscription = this.platform.registerBackButtonAction(() => {
      this.viewCtrl.dismiss();
    })
  }

  ngOnDestroy() {
    if(this.backbuttonSubscription) {
      this.backbuttonSubscription();
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  getCGV() {
    this.loading = true;
    this.reducceService.getCGV().subscribe(res => {
      this.cgv = res;
      this.loading = false;
    }, error => {
      this.loading = false;
      this.error = true;
    })
  }
}



// WEBPACK FOOTER //
// ./src/core/cgv-modal/cgv-modal.component.ts